module.exports = __webpack_public_path__ + "static/assets/c4d6ed18d38d38ca3d03112a33c4d935.png";